import React from 'react';
import styled from 'styled-components';
import Icon from '../../../../../../common/Icon';
import { BodyFour } from '../../../../../../styles/theme/default/typography';

const Wrapper = styled.div`
  border: ${({ border }) => (border ? border : '1px solid #D8D8D8')};
  display: flex;
  align-items: center;
  padding: 20px 15px;
  cursor: pointer;

  .btn-link {
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    color: ${({ theme }) => theme.colors.french};
    text-decoration: underline;
  }

  .extend-logo {
    width: 50px;
    margin-bottom: 2px;
  }

  .icon-container {
    margin-right: 10px;
  }
`;

function ExtendBox({
  extendPlanSelected,
  handleClick,
  removePlan,
  cheapestPlan
}) {
  const getTermCopy = term => {
    if (term == 12) return '1 Year';
    if (term == 24) return '2 Year';
    if (term == 36) return '3 Year';
    if (term == 60) return '5 Year';
    return term;
  };

  return (
    <Wrapper
      border={extendPlanSelected ? '2px solid #2A5CAF' : '1px solid #d9d9d9'}
      onClick={e => {
        if (extendPlanSelected) return;
        handleClick(e);
      }}
    >
      <div className="icon-container">
        <Icon
          icon="ti-ribbon"
          size={38}
          color={extendPlanSelected ? '#2A5CAF' : '#6C6C6C'}
        />
      </div>
      <div className="extend-content">
        {extendPlanSelected ? (
          <BodyFour>
            {getTermCopy(extendPlanSelected.term)} Accident Protection Plan by{' '}
            <img
              src="https://theinside.imgix.net/common/extend-logo-01.svg?auto=format"
              alt="extend logo"
              className="extend-logo"
            />{' '}
            (+$
            {extendPlanSelected.price / 100} per item){' '}
            <button className="btn-link" onClick={() => removePlan()}>
              Remove
            </button>
          </BodyFour>
        ) : (
          <BodyFour>
            Add an additional 2, 3, or 5 years of accident protection offered by{' '}
            <img
              src="https://theinside.imgix.net/common/extend-logo-01.svg?auto=format"
              alt="extend logo"
              className="extend-logo"
            />{' '}
            {cheapestPlan && `from $${cheapestPlan.price / 100} `}
            <button className="btn-link" onClick={handleClick}>
              Select Plan
            </button>
          </BodyFour>
        )}
      </div>
    </Wrapper>
  );
}

export default ExtendBox;
